import { render, staticRenderFns } from "./HousePeriodicalAssessmentList.vue?vue&type=template&id=f513d73e"
import script from "./HousePeriodicalAssessmentList.vue?vue&type=script&lang=js"
export * from "./HousePeriodicalAssessmentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports